<template>
  <el-footer>Footer</el-footer>
</template>

<script>
  export default {
    name: 'Footer',
    components: {},
    props: {},
    data() {
      return {}
    },
    watch: {},
    computed: {},
    methods: {},
    created() {},
    mounted() {}
  }

</script>
<style lang="scss" scoped>


</style>
